"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditableField = void 0;
var EditableField;
(function (EditableField) {
    EditableField["MaxStock"] = "maxStock";
    EditableField["CurrStock"] = "currStock";
    EditableField["Price"] = "price";
    EditableField["All"] = "all";
})(EditableField || (exports.EditableField = EditableField = {}));
